import { action } from 'satcheljs';
import { EntityCommand } from 'owa-graph-schema';
import type { OwaNovaAction, OwaNovaActionInput } from '../types';

export const onAddinTrigger = action<OwaNovaActionInput, OwaNovaAction<'AddIn'>>(
    'onAddinTrigger',
    (command: EntityCommand) => ({
        kind: 'AddIn',
        command,
    })
);
